import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function PurchaseSection() {
  const [selected, setSelected] = useState<'base' | 'completa'>('completa');
  return <section id="compra" className="bg-white py-1 md:py-24 px-2 md:px-4 scroll-mt-10" data-id="element-216">
      <div className="max-w-2xl mx-auto" data-id="element-217">
        {/* TITLE */}
        <div className="text-center mb-1.5 md:mb-12" data-id="element-218">
          <h2 className="text-xl md:text-5xl font-bold text-navy mb-0.5 md:mb-4" data-id="element-219">
            Tu bebé se merece dormir bien. Vos también.
          </h2>
          <p className="text-xs md:text-xl text-navy/60" data-id="element-220">Elegi tu plan:</p>
        </div>

        <div className="flex flex-col gap-1.5 md:gap-4" data-id="element-221">
          {/* ORDER BUMP 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('base')} className={`relative rounded-lg md:rounded-xl p-2 md:p-5 cursor-pointer transition-all border ${selected === 'base' ? 'border-navy/30 bg-navy/5' : 'border-gray-200 bg-gray-50'}`} data-id="element-222">
            <div className="flex items-center gap-2.5 md:gap-4" data-id="element-223">
              <div className="flex-shrink-0" data-id="element-224">
                <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selected === 'base' ? 'border-gold' : 'border-gray-300'}`} data-id="element-225">
                  {selected === 'base' && <div className="w-2 h-2 rounded-full bg-gold" data-id="element-226" />}
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-227">
                <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider mb-0 md:mb-1" data-id="element-228">
                  ⭐ SISTEMA ORIGINAL
                </p>
                <h3 className="text-sm md:text-xl font-bold text-navy leading-tight" data-id="element-229">
                  Método Noches de Paz™
                </h3>
                <p className="text-navy/50 text-[10px] md:text-sm" data-id="element-230">
                  6 Tomos + 3 Bonus
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-231">
                <p className="text-navy/40 text-[10px] md:text-sm line-through" data-id="element-232">
                  $39.990
                </p>
                <p className="text-gold font-bold text-lg md:text-3xl" data-id="element-233">
                  $19.990
                </p>
              </div>
            </div>
          </motion.div>

          {/* ORDER BUMP 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative" data-id="element-234">
            {/* Recommended badge */}
            <div className="text-center mb-0" data-id="element-235">
              <div className="inline-block bg-navy text-gold border border-gold/40 rounded-t-lg md:rounded-t-xl px-3 md:px-6 py-1 md:py-2" data-id="element-236">
                <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider" data-id="element-237">
                  🏆 LA MEJOR OPCIÓN PARA NO FALLAR
                </p>
              </div>
            </div>

            <div onClick={() => setSelected('completa')} className={`relative rounded-lg md:rounded-xl rounded-t-none p-2 md:p-5 cursor-pointer transition-all border-2 ${selected === 'completa' ? 'border-gold bg-navy/5' : 'border-gold/30 bg-gray-50'}`} data-id="element-238">
              <div className="flex items-center gap-2.5 md:gap-4" data-id="element-239">
                <div className="flex-shrink-0" data-id="element-240">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selected === 'completa' ? 'border-gold' : 'border-gray-300'}`} data-id="element-241">
                    {selected === 'completa' && <div className="w-2 h-2 rounded-full bg-gold" data-id="element-242" />}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-243">
                  <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider mb-0 md:mb-1" data-id="element-244">
                    👑 PACK COMPLETO
                  </p>
                  <h3 className="text-sm md:text-xl font-bold text-navy leading-tight" data-id="element-245">
                    Edición Completa 💎
                  </h3>
                  <p className="text-navy/50 text-[10px] md:text-sm" data-id="element-246">
                    6 Tomos + 3 Bonus + Noches Difíciles + Dormir Sin Culpa
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-247">
                  <p className="text-navy/40 text-[10px] md:text-sm line-through" data-id="element-248">
                    $59.990
                  </p>
                  <p className="text-gold font-bold text-lg md:text-3xl" data-id="element-249">
                    $29.990
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* CTA BUTTON */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-0 md:mt-2" data-id="element-250">
            <a href={selected === 'completa' ? 'https://casaenpaz.com.ar/checkouts/cn/hWNBKEXVjWQbuNXLZI732R5W/es-ar?_r=AQABdtZJvOu5PakMc-ms_X1mkEiWKOog0BaSIeqjdorYvJI' : 'https://casaenpaz.com.ar/checkouts/cn/hWNBKEFU3MSDCS9WoSgveGmI/es-ar?_r=AQABEVJbYZtskdXm1yaFkWkQDv534SW9LE_ET2s8d8RJ2M4'} className="block w-full text-center bg-[#1e3a5f] hover:bg-[#2a4f7a] text-white text-sm md:text-xl font-extrabold uppercase tracking-wide py-4 md:py-5 px-5 md:px-8 rounded-xl md:rounded-2xl shadow-[0_0_30px_rgba(30,58,95,0.6)] transition-all transform hover:scale-[1.02] animate-pulse" data-id="element-251">
              {selected === 'completa' ? 'ADQUIRIR EDICIÓN COMPLETA AHORA' : 'ADQUIRIR MÉTODO NOCHES DE PAZ™ AHORA'}
            </a>
            <p className="text-center text-navy/50 text-[10px] md:text-sm mt-0.5 md:mt-2" data-id="element-252">
              ${selected === 'completa' ? '29.990' : '19.990'} · Acceso
              Inmediato
            </p>
          </motion.div>

          {/* DESCRIPTION CARD */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-gray-50 rounded-lg md:rounded-2xl p-2 md:p-6 mt-0 md:mt-2 border border-gray-200" data-id="element-253">
            <h4 className="text-navy font-bold text-xs md:text-lg mb-1 md:mb-4" data-id="element-254">
              La solución para mamás que quieren dormir:
            </h4>
            <div className="space-y-0.5 md:space-y-2 text-navy/70 text-[10px] md:text-sm" data-id="element-255">
              <p data-id="element-256">
                <span className="font-bold text-navy" data-id="element-257">
                  📘 MÉTODO NOCHES DE PAZ:
                </span>{' '}
                Plan paso a paso con los 6 Tomos + 3 Bonus.
              </p>
              {selected === 'completa' && <>
                  <p data-id="element-258">
                    <span className="font-bold text-navy" data-id="element-259">
                      + 🌙 NOCHES DIFÍCILES:
                    </span>{' '}
                    Te dice qué hacer cuando tu bebé se enferma, está con
                    dientes, entra en regresión o cambia de rutina y el sueño se
                    desordena.
                  </p>
                  <p data-id="element-260">
                    <span className="font-bold text-navy" data-id="element-261">
                      + 💜 DORMIR SIN CULPA:
                    </span>{' '}
                    Te ayuda a aplicar el método con más seguridad emocional,
                    para que tu bebé duerma mejor sin que vos sientas culpa por
                    acompañarlo de esta forma.
                  </p>
                </>}
            </div>
            <p className="text-pink-500 font-bold text-[10px] md:text-sm mt-1 md:mt-4" data-id="element-262">
              Ahorrá ${selected === 'completa' ? '30.000' : '20.000'} solo por
              las próximas 24hs.
            </p>
          </motion.div>
        </div>

        {/* TRUST BADGES */}
        <div className="mt-1.5 md:mt-6 text-center" data-id="element-263">
          <p className="text-[9px] md:text-xs text-navy/40 flex items-center justify-center gap-1" data-id="element-264">
            <Lock size={9} className="md:w-3 md:h-3" data-id="element-265" /> Pago seguro · Acceso
            inmediato · PDF en minutos
          </p>
        </div>
      </div>
    </section>;
}